import React from 'react';
import { motion } from 'framer-motion';
import { heroText, imageReveal, fadeInUp } from '../../utils/animations';
import Button from '../common/Button';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden hero-gradient pt-32 sm:pt-20">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, #8B7355 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 py-32 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Left Content */}
          <motion.div
            className="text-left relative"
            initial="hidden"
            animate="visible"
          >
            <motion.h1
              className="text-5xl md:text-6xl lg:text-7xl font-serif text-dark mb-6 leading-tight"
              variants={heroText}
            >
              Transforming Spaces
              <br />
              with
              <span className="text-primary-brown"> Artistry</span>
              <br />
              and
              <span className="text-primary-brown"> Precision</span>
            </motion.h1>

            <motion.p
              className="text-lg md:text-xl text-dark-light mb-8 max-w-xl leading-relaxed"
              variants={fadeInUp}
            >
              Expert solutions for paint, coatings, and construction finishing.
            </motion.p>

            <motion.div
              className="flex flex-wrap gap-4"
              variants={fadeInUp}
            >
              <Button
                variant="primary"
                size="large"
                onClick={() => {
                  const element = document.getElementById('services');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                View Services
              </Button>
              <Button
                variant="outline"
                size="large"
                onClick={() => navigate('/about')}
              >
                Learn More
              </Button>
            </motion.div>
          </motion.div>

          {/* Right Image */}
          <motion.div
            className="relative flex flex-col items-end"
            variants={imageReveal}
            initial="hidden"
            animate="visible"
          >
            <div className="relative rounded-lg overflow-hidden shadow-2xl">
              {/* Hero Homepage Image */}
              <div className="aspect-square bg-gradient-to-br from-primary-tan to-primary-beige">
                <img
                  src="/images/Homepage Picture .PNG"
                  alt="Precision • Perfection • CraftCoat - Modern architectural design"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Decorative Corner */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-primary-brown opacity-10 rounded-bl-full"></div>
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-primary-brown opacity-10 rounded-tr-full"></div>
            </div>

            {/* Floating Badge - Below image on right side */}
            <motion.div
              className="mt-6 bg-white rounded-lg shadow-xl p-6"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.8, duration: 0.5 }}
            >
              <p className="text-3xl font-serif text-primary-brown font-bold">35+</p>
              <p className="text-sm text-dark-light">Years Experience</p>
            </motion.div>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator - Bottom center */}
      <motion.div
        className="absolute bottom-24 left-1/2 transform -translate-x-1/2"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 0.8, repeat: Infinity, repeatType: 'reverse' }}
      >
        <div className="w-6 h-10 border-2 border-primary-brown rounded-full flex items-start justify-center p-2">
          <motion.div
            className="w-1.5 h-1.5 bg-primary-brown rounded-full"
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          />
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;